import { render, staticRenderFns } from "./FooterMobile.vue?vue&type=template&id=36d171e4&scoped=true"
import script from "./FooterMobile.vue?vue&type=script&lang=js"
export * from "./FooterMobile.vue?vue&type=script&lang=js"
import style0 from "./FooterMobile.vue?vue&type=style&index=0&id=36d171e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d171e4",
  null
  
)

export default component.exports